module.exports = __webpack_public_path__ + "img/guide-wx.7a62c9c8.png";